import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Image } from "@react-pdf/renderer";
import { logos } from "../../../hook/Arreglos";

// Estilos del PDF
const styles = StyleSheet.create({
    // Página y encabezado
    page: { padding: 20, fontFamily: "Helvetica" },
    header: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 10,
    },
    logo: { width: 80, height: "auto" },
    contractNumber: { fontSize: 10, fontWeight: "bold", marginTop: 5 },

    // Tarjetas de información
    cardContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 10, // Espaciado entre tarjetas
    },
    card: {
        width: "32%", // Ancho ajustado para que los cuadros sean más anchos
        borderWidth: 1,
        borderColor: "#ccc",
        borderRadius: 5,
        padding: 8,
        backgroundColor: "#f9f9f9",
    },
    cardTitle: { fontSize: 10, fontWeight: "bold", color: "#000", marginBottom: 6 }, // Títulos en negro
    cardText: { fontSize: 7, color: "#333", marginBottom: 3 }, // Valores en gris oscuro
    divider: { borderBottomWidth: 1, borderBottomColor: "#ccc", marginVertical: 2 },

    // Tabla
    section: { marginBottom: 15 },
    title: {
        fontSize: 10, // Ajusta el tamaño del texto si es necesario
        fontWeight: "bold", // Asegúrate de que sea negrita
        textAlign: "center", // Centra el texto
        marginBottom: 8, // Margen inferior para separación
        backgroundColor: "#000", // Fondo negro
        color: "#fff", // Texto blanco
        padding: 4, // Agrega un poco de espacio interno
        textTransform: "uppercase", // Opcional: convierte el texto a mayúsculas
    },
    tableHeader: {
        backgroundColor: "#000",
        color: "#fff",
        padding: 3,
        fontSize: 8,
        fontWeight: "bold",
        textAlign: "center",
    },
    tableRow: { flexDirection: "row", borderBottomWidth: 1, borderColor: "#ccc", padding: 3 },
    tableCell: { fontSize: 7, padding: 2, textAlign: "left" }, // Justificar texto a la izquierda

    // Totales
    totalContainer: {
        marginTop: 10,
        alignItems: "flex-end", // Alinear todo a la derecha
        width: "100%", // Asegurar que el contenedor ocupe todo el ancho disponible
    },
    totalRow: {
        flexDirection: "row",
        justifyContent: "space-between", // Espaciado entre la etiqueta y el valor
        alignItems: "center", // Centrar verticalmente los elementos
        width: "30%", // Contenedor más compacto
        borderBottomWidth: 1, // Agregar una línea separadora
        borderBottomColor: "#ccc", // Color de la línea separadora
        paddingVertical: 2, // Espaciado interno para evitar que se vean amontonados
    },
    totalLabel: {
        fontSize: 8,
        fontWeight: "bold",
        textAlign: "left", // Alinear texto a la izquierda
        flex: 1, // Mantener proporción flexible
        marginRight: 2, // Espacio mínimo entre etiqueta y valor
    },
    totalValue: {
        fontSize: 8,
        textAlign: "right", // Alinear los valores numéricos a la derecha
        flex: 1, // Mantener proporción flexible
    },
});

// Función para asignar el logo correspondiente a un hotel
const asignarLogo = (idHotel) => {
    const hotel = logos.find((item) => item.id === Number(idHotel));
    return hotel ? hotel.logo : "/assets/logo2.jpg";
};

// Componente principal del PDF
const PDFGenerator = ({ formulario, monedaActiva }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            {/* Encabezado */}
            <View style={styles.header}>
                <Image src={asignarLogo(formulario.hotelSeleccionado)} style={styles.logo} />
                <Text style={styles.contractNumber}>#{formulario.consecutivo}</Text>
            </View>

            {/* Tarjetas de información */}
            <View style={styles.cardContainer}>
                {/* Información del Ejecutivo */}
                <View style={styles.card}>
                    <Text style={styles.cardTitle}>Información del Ejecutivo</Text>
                    <Text style={styles.cardText}>Ejecutiva: {formulario.nombreEjecutivo}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Cargo: {formulario.cargoEjecutivo}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Correo Electrónico: {formulario.correoEjecutivo}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Teléfono: {formulario.telefonoEjecutivo}</Text>
                </View>

                {/* Información del Cliente */}
                <View style={styles.card}>
                    <Text style={styles.cardTitle}>Información del Cliente</Text>
                    <Text style={styles.cardText}>Empresa: {formulario.empresaSeleccionada}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Cliente: {formulario.nombreCliente}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Correo Electrónico: {formulario.correoCliente}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Teléfono: {formulario.telefonoCliente}</Text>
                </View>

                {/* Información del Contrato */}
                <View style={styles.card}>
                    <Text style={styles.cardTitle}>Información de contrato</Text>
                    <Text style={styles.cardText}>Número contrato: #{formulario.consecutivo}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Fecha contrato: {formulario.fechaCreacion}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Fechas Evento: {formulario.fechaSeleccionadas || "Sin definir"}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Nombre Evento: {formulario.nombreEvento}</Text>
                </View>
            </View>

            {/* Tabla de requerimientos */}
            {formulario.requerimientos.length > 0 && (
                <View>
                    <Text style={styles.title}>REQUERIMIENTO DE EVENTO</Text>
                    <View>
                        <View style={[styles.tableRow, { backgroundColor: "#f9f9f9" }]}>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Fecha</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Hora</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Cant.</Text>
                            <Text style={[styles.tableCell, { width: "25%" }]}>Desc. artículo</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Días</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Salones</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Precio {monedaActiva}</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Subto. {monedaActiva}</Text>
                        </View>

                        {formulario.requerimientos.map((requerimiento, index) => (
                            <View key={index} style={styles.tableRow}>
                                <Text style={[styles.tableCell, { width: "10%" }]}>
                                    {requerimiento.fecha
                                        ? requerimiento.fecha
                                              .toString()
                                              .split(",")
                                              .map((part, idx) => (
                                                  <Text key={idx} style={{ display: "block" }}>
                                                      {part.trim()}
                                                  </Text>
                                              ))
                                        : "Sin definir"}
                                </Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.hora || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.cantidad}</Text>
                                <Text style={[styles.tableCell, { width: "25%" }]}>{requerimiento.descripcionArticulo}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.dias}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.salon || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.precio}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.subtotal}</Text>
                            </View>
                        ))}
                    </View>

                    <View style={styles.totalContainer}>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>SUB TOTAL {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.subtReq_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>13% IM.VENTAS {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.treceReq_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>10% IMP.SERV {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.diezReq_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>TOTAL A&B {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.totalReq_Subt_con}</Text>
                        </View>
                    </View>
                </View>
            )}
            <View style={{ height: 20 }} />
            {formulario.otroServicios.length > 0 && (
                <View>
                    <Text style={styles.title}>OTROS SERVICIOS</Text>
                    <View>
                        <View style={[styles.tableRow, { backgroundColor: "#f9f9f9" }]}>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Fecha</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Hora</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Cant.</Text>
                            <Text style={[styles.tableCell, { width: "25%" }]}>Desc. artículo</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Días</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Salones</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Precio {monedaActiva}</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Subto. {monedaActiva}</Text>
                        </View>

                        {formulario.otroServicios.map((requerimiento, index) => (
                            <View key={index} style={styles.tableRow}>
                                <Text style={[styles.tableCell, { width: "10%" }]}>
                                    {requerimiento.fecha
                                        ? requerimiento.fecha
                                              .toString()
                                              .split(",")
                                              .map((part, idx) => (
                                                  <Text key={idx} style={{ display: "block" }}>
                                                      {part.trim()}
                                                  </Text>
                                              ))
                                        : "Sin definir"}
                                </Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.hora || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.cantidad}</Text>
                                <Text style={[styles.tableCell, { width: "25%" }]}>{requerimiento.descripcionArticulo}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.dias}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.salon || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.precio}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.subtotal}</Text>
                            </View>
                        ))}
                    </View>
                    <View style={styles.totalContainer}>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>SUB TOTAL {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.subtOtro_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>13% IM.VENTAS {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.treceOtro_Subt_con}</Text>
                        </View>

                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>TOTAL A&B {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.totalOtro_Subt_con}</Text>
                        </View>
                    </View>
                </View>
            )}
            <View style={{ height: 20 }} />

            {formulario.requerimientoshabitaciones.length > 0 && (
                <View>
                    <Text style={styles.title}>REQUERIMIENTOS DE HABITACIONES</Text>
                    <View>
                        <View style={[styles.tableRow, { backgroundColor: "#f9f9f9" }]}>
                            <Text style={[styles.tableCell, { width: "15%" }]}>Fecha In</Text>
                            <Text style={[styles.tableCell, { width: "15%" }]}>Fecha Out</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Noches</Text>
                            <Text style={[styles.tableCell, { width: "25%" }]}>Desc. Habitación</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Cant. Habitación</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Tarifa * Noche {monedaActiva}</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Sub Total {monedaActiva}</Text>
                        </View>

                        {formulario.requerimientoshabitaciones.map((requerimiento, index) => (
                            <View key={index} style={styles.tableRow}>
                                <Text style={[styles.tableCell, { width: "15%" }]}>{requerimiento.fechin_roomreq_con || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "15%" }]}>{requerimiento.fechout_roomreq_con || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.noches_roomreq_con || "0"}</Text>
                                <Text style={[styles.tableCell, { width: "25%" }]}>{requerimiento.dec_roomreq_con || "Sin descripción"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.cant_roomreq_con || "0"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.tarifa_roomreq_con || "0.00"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.sub_roomreq_con || "0.00"}</Text>
                            </View>
                        ))}
                    </View>
                    <View style={styles.totalContainer}>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>SUB TOTAL {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.subtsubtRoom_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>13% IM.VENTAS {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.trecesubtRoom_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>TIP MUCAMA {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.mucamasubtRoom_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>TOTAL A&B {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.totalsubtRoom_Subt_con}</Text>
                        </View>
                    </View>
                </View>
            )}
            <View style={{ height: 20 }} />
            {/* Salto de línea */}
            <View style={{ height: 20 }} />
            <View>
                {/* Título */}
                <Text style={styles.title}>TALES GENERAL</Text>
                {/* Contenedor del total */}
                <View style={{ flexDirection: "row", justifyContent: "flex-end", marginTop: 5 }}>
                    <View
                        style={{
                            minWidth: 120,
                            borderWidth: 1,
                            borderColor: "#ccc",
                            padding: 5,
                            backgroundColor: "#f5f5f5",
                            borderRadius: 4,
                            alignItems: "center", // Alinea el texto centrado dentro del contenedor
                        }}
                    >
                        <Text style={{ fontSize: 10, fontWeight: "bold", textAlign: "right" }}>{formulario.totalGlobalCotizacion}</Text>
                    </View>
                </View>
            </View>
            <View>
                {/* Título */}
                <View style={{ marginBottom: 10 }}>
                    <Text style={{ fontSize: 8, fontWeight: "bold", marginBottom: 4 }}>Notas: {formulario.notaCoti || ""}</Text>
                </View>
            </View>
        </Page>
        {/* Segunda página */}
        <Page size="A4" style={styles.page}>
            <View>
                {/* Título Principal */}
                <Text
                    style={{
                        fontSize: 8, // Tamaño ajustado para un título más proporcionado
                        fontWeight: "bold",
                        textAlign: "center",
                        marginBottom: 15,
                        textTransform: "uppercase",
                    }}
                >
                    Políticas de Contrato
                </Text>

                {/* Subtítulo */}
                <Text
                    style={{
                        fontSize: 8, // Tamaño reducido para el subtítulo
                        fontWeight: "bold",
                        textAlign: "left",
                        marginBottom: 10,
                        textDecoration: "underline",
                    }}
                >
                    Información adicional
                </Text>

                {/* Cuerpo del Texto */}
                <Text
                    style={{
                        fontSize: 8, // Tamaño más pequeño para un aspecto formal y limpio
                        lineHeight: 1.4, // Espaciado entre líneas ajustado
                        textAlign: "justify",
                        marginBottom: 10,
                    }}
                >
                    El presente <Text style={{ fontWeight: "bold" }}>Acuerdo de Evento (el “Acuerdo”)</Text> es celebrado entre:{" "}
                    <Text style={{ fontWeight: "bold" }}> {formulario.celebro_contrato} </Text>, Cédula de identidad:{" "}
                    <Text style={{ fontWeight: "bold" }}> {formulario.cedula_contrato} </Text>.
                </Text>
                <Text
                    style={{
                        fontSize: 8,
                        lineHeight: 1.4,
                        textAlign: "justify",
                        marginBottom: 20,
                    }}
                >
                    Representando a la empresa: <Text style={{ fontWeight: "bold" }}>{formulario.empresaC_contrato}</Text> (“usted”, “El Cliente” o
                    “su/suyo”) y la empresa que actualmente opera con el nombre de{" "}
                    <Text style={{ fontWeight: "bold" }}> {formulario.hotelC_contrato} </Text> (el “Hotel” o “nosotros” o “nuestro”).
                </Text>

                {/* Sección Parte 1 */}
                <Text
                    style={{
                        fontSize: 8, // Tamaño más pequeño para consistencia
                        fontWeight: "bold",
                        textAlign: "center",
                        marginTop: 10, // Espacio reducido para subir la sección
                        textTransform: "uppercase",
                    }}
                >
                    Parte 1: Políticas del Hotel
                </Text>
                <Text
                    style={{
                        fontSize: 8, // Tamaño formal y legible
                        lineHeight: 1.4, // Espaciado entre líneas
                        textAlign: "justify",
                        marginTop: 10, // Espacio superior para separación
                    }}
                >
                    1. El Hotel únicamente preparará alimentos para la cantidad definitiva garantizada de comensales, y no garantiza que preparará el
                    salón para una cantidad de comensales que supere en más de 5% la cantidad definitiva garantizada de asistentes.
                    {"\n\n"}
                    2. Gastos Adicionales: El cliente se compromete a pagar al Hotel todos los alimentos, bebidas y otros servicios no incluidos en el
                    Acuerdo o en los pedidos del Evento, pero que usted solicite durante el Evento, el mismo día de evento.
                    {"\n\n"}
                    3. Alimentos y Bebidas Servidos en el hotel: Todos los alimentos y bebidas que se sirven en las funciones asociadas con el evento
                    deben ser proporcionados, preparados y servidos por el hotel, y deben ser consumidos en las instalaciones del hotel. No se permite
                    el ingreso de alimentos ni bebidas, se permite únicamente licor a excepción de cervezas en cuyo caso aplicará el monto de
                    descorche establecido por el hotel.
                    {"\n\n"}
                    4. Exhibiciones y Decoraciones; Bienes Propios: El hotel no se hará responsable por ninguna pérdida o daños a bienes de su
                    propiedad o que pertenezcan a los asistentes, y no brindamos ninguna cobertura de seguro al respecto. Deberá obtener aprobación
                    por escrito para colocar cualquier tipo de exhibición o decoración, y nos reservamos el derecho de contratar, a su costo, personal
                    del Hotel para instalar o retirar dichos elementos. Si lo solicita, podemos informarle a cuanto ascenderían dichos cargos en las
                    fechas de su Evento. No se hará resguardo de bienes por más de un día previo y posterior a la fecha del evento.
                    {"\n\n"}
                    5. Contratistas Externos: Si durante su Evento opta por utilizar contratistas externos en las instalaciones del Hotel, deberá
                    notificarnos como mínimo 7 días antes. Podría exigirse a los contratistas que presenten una constancia de que cuentan con
                    cobertura de seguro y que firmen nuestro acuerdo de indemnidad para poder brindar servicios en las instalaciones del Hotel. Cada
                    proveedor deberá firmar documento con las políticas de ingreso, montaje y desmontaje así como sujetarse a las horas asignadas para
                    tal fin.
                    {"\n\n"}
                    6. Desarrollo del Evento: El cliente acepta que en el uso de los espacios funcionales no creará perturbaciones irrazonables para
                    otros huéspedes ni para otras reuniones o actividades debido a, por ejemplo, ruido excesivo, máquinas de humo o niebla, hielo
                    seco, cañones de confeti, velas, incienso o cualquier otra actividad que genere olores ofensivos. El cliente no utilizará ninguno
                    de tales elementos sin la aprobación previa de la gerencia del Hotel. El Hotel ejercerá un criterio razonable y tomará en cuenta
                    la naturaleza de la actividad a la hora de determinar si el evento de hecho está creando perturbaciones irrazonables. El Hotel se
                    reserva el derecho de suspender de manera inmediata la actividad o el uso del espacio de reuniones si el cliente no cumple sin
                    demora el pedido del Hotel de reducir o eliminar las perturbaciones, en cuyo caso el cliente seguirá siendo responsable de pagar
                    todos los cargos relacionados con el desarrollo de la actividad o el uso del espacio de reuniones, sin tener obligación de pagar
                    reembolso alguno.
                    {"\n\n"}
                    7. Política de música: Los eventos que están programados para tener música en las áreas públicas deben iniciar a las 08:00 AM y
                    terminar a las 10:00 PM para que los huéspedes que están alrededor de estas áreas, puedan descansar. No obstante, el evento puede
                    continuar sin música. En caso de incumplimiento se cobrará una multa.
                    {"\n\n"}
                    8. Artículos desatendidos: El hotel no puede garantizar la seguridad de los bienes depositados en las salas de función. Arreglos
                    especiales se pueden hacer con el hotel para asegurar un número limitado de objetos de valor.
                    {"\n\n"}
                    9. Horas extra: En caso que el evento se extienda más allá de la hora pactada en el contrato se cobrará $20 por salonero por hora
                    y $40 por el capitán por hora en el evento, así como $100 por hora adicional de uso de salón o área de evento. Además de los
                    alimentos y bebidas que sean consumidos en el tiempo adicional.
                    {"\n\n"}
                    10. Protección contra Incendios: Para preservar la seguridad de las personas y la propiedad, no podrán utilizarse fuegos
                    artificiales o artículos inflamables en las zonas interiores del Hotel. La configuración de todas las salas deberá ajustarse a las
                    normas nacionales y locales, incluidas las relativas a la cantidad de asistentes, los pasillos obligatorios, la distancia desde el
                    techo y las salidas de emergencia. Todos los cargos por la obtención de permisos, la aprobación de planos de planta y la presencia
                    de personal de bomberos (según corresponda) correrán por su cuenta, y el Hotel deberá recibir copias de todos los permisos
                    definitivos otorgados como mínimo tres días antes del Evento. Si necesita servicios de izado o grúas para este Evento, deberá
                    coordinar todos los servicios a través del proveedor de servicios audiovisuales del Hotel o con el Hotel (según corresponda), y
                    usted deberá correr con todos los gastos relacionados.
                    {"\n\n"}
                    11. Seguridad: Si el Hotel, según su criterio razonable, estima que es necesario para mantener un nivel adecuado de seguridad en
                    vista de la envergadura o la naturaleza del Evento, el Cliente contratará, a su costo, personal de seguridad de una empresa de
                    seguridad habilitada, que deberá ser aprobado de antemano por el Hotel. Dicho personal de seguridad no portará armas. Podrá
                    exigirse a la empresa de seguridad del Cliente que presente una constancia de que cuenta con cobertura de seguro y que firme
                    nuestro acuerdo de indemnidad para poder brindar servicios en las instalaciones del Hotel.
                </Text>
                {/* Sección Parte 2 */}
                <Text
                    style={{
                        fontSize: 8, // Tamaño más pequeño para consistencia
                        fontWeight: "bold",
                        textAlign: "center",
                        marginTop: 10, // Espacio reducido para subir la sección
                        textTransform: "uppercase",
                    }}
                >
                    PAGO
                </Text>
                <Text
                    style={{
                        fontSize: 8, // Tamaño formal y legible
                        lineHeight: 1.4, // Espaciado entre líneas
                        textAlign: "justify",
                        marginTop: 10, // Espacio superior para separación
                    }}
                >
                    1. Forma de pago: <Text style={{ fontWeight: "bold" }}> {formulario.formapago_contrato} </Text>
                    {"\n\n"}
                    2. En caso de ser con prepago.
                    {"\n\n"}
                    3. El Cliente se compromete a pagar un 100% de los cargos totales estimados para la Cuenta Maestra o los ingresos totales
                    acordados (lo que sea mayor), según el siguiente calendario de depósitos.
                    {"\n\n"}
                    4. En caso de ser a crédito.
                    {"\n\n"}
                    5. El cliente se compromete a cancelar el monto total del evento en el plazo crédito aprobado por el departamento de contabilidad
                    del hotel una vez generada la factura.
                    {"\n\n"}
                    6. Si los adelantos de pago o los depósitos no se realizan dentro del plazo estipulado, el Hotel tendrá derecho, a su criterio, a
                    considerar que el Acuerdo ha quedado cancelado y solicitar al Cliente el pago de los cargos por cancelación aplicables que se
                    establecen en este Acuerdo.
                    {"\n\n"}
                    7. El Hotel prefiere que el Cliente pague todos los depósitos y los cargos a la Cuenta Maestra mediante transferencia electrónica
                    de fondos. En una comunicación posterior, el Hotel le enviará al cliente su información bancaria.
                    {"\n\n"}
                    8. Si el Cliente prefiere pagar con tarjeta de crédito, el Hotel le enviará el link donde podrá efectuar el pago de forma sencilla
                    y segura. Ante discrepancias con respecto a los cargos, el cliente deberá presentar una lista desglosada de los cargos que objeta
                    para que el Hotel pueda debitar de la tarjeta de crédito los cargos no objetados y esperar a la resolución para cobrar el saldo
                    restante.
                </Text>
                <Text
                    style={{
                        fontSize: 8, // Tamaño más pequeño para consistencia
                        fontWeight: "bold",
                        textAlign: "center",
                        marginTop: 10, // Espacio reducido para subir la sección
                        textTransform: "uppercase",
                    }}
                >
                    CUMPLIMIENTO
                </Text>
                <Text
                    style={{
                        fontSize: 8, // Tamaño legible y formal
                        lineHeight: 1.4, // Espaciado entre líneas
                        textAlign: "justify",
                        marginTop: 10, // Espacio superior para separación
                    }}
                >
                    Impuestos y las concesiones que ofrece el Hotel se basan, en parte, en el total de ingresos que el Hotel prevé que se generarán a
                    partir de su acuerdo de usar y pagar por las habitaciones, las salas de reuniones y las funciones que se describen en el Acuerdo.
                    Usted acuerda y entiende que en caso de que el Cliente no cumpla con las obligaciones que ha asumido, nosotros habremos perdido la
                    oportunidad de ofrecer nuestras instalaciones no utilizadas a otros clientes, ya sea de forma individual o como parte de otro
                    conjunto de eventos, y que tendremos que incurrir en costos adicionales para revender el inventario que le hayamos vendido a
                    usted.
                </Text>

                <Text
                    style={{
                        fontSize: 8, // Tamaño levemente mayor para destacar
                        fontWeight: "bold",
                        textAlign: "center",
                        marginVertical: 15, // Espaciado superior e inferior
                    }}
                >
                    CANCELACIÓN TOTAL
                </Text>

                <Text
                    style={{
                        fontSize: 8,
                        lineHeight: 1.4,
                        textAlign: "justify",
                        marginBottom: 10, // Espaciado inferior
                    }}
                >
                    Las tasas y las concesiones que ofrecemos en el acuerdo se basan en el total de ingresos que prevemos que se generarán a partir de
                    su acuerdo de usar y pagar por las salas de reuniones y las funciones que se describen en el Acuerdo. Usted acuerda y entiende que
                    ante una cancelación total, nosotros habremos perdido la oportunidad de ofrecer nuestras instalaciones no utilizadas a otros, y
                    que tendremos que incurrir en costos adicionales para revender el inventario que le hayamos vendido a usted.
                </Text>

                <Text
                    style={{
                        fontSize: 8,
                        lineHeight: 1.4,
                        textAlign: "justify",
                    }}
                >
                    Si el cliente cancela la totalidad del Evento por cualquier motivo, lo que incluye realizar su reunión/función en otro hotel,
                    usted entiende que el Hotel no solo sufrirá pérdida de ingresos por los espacios que no venda, sino también pérdidas con respecto
                    a los demás cargos adicionales en que el cliente y las personas que se hubieran quedado en el hotel habrían incurrido, por
                    ejemplo, servicios de alimentos y bebidas en restaurantes, venta minorista de alimentos y bebidas y uso de las instalaciones
                    recreativas (colectivamente, los “pagos complementarios”), que a menudo superan los ingresos perdidos sobre las habitaciones no
                    utilizadas. Las partes reconocen que es difícil cuantificar tales pérdidas, y han convenido en que Hotel aplicará un cargo por
                    cancelación (el “Cargo por Cancelación”) como multa, según lo permita la legislación local. El Cargo por Cancelación se calculará
                    como un porcentaje de los ingresos acordados en el contrato, de la siguiente manera:
                </Text>
                <View
                    style={{
                        marginTop: 20, // Separación del contenido anterior
                        marginHorizontal: 10, // Márgenes laterales
                    }}
                >
                    {/* Encabezado de la tabla */}
                    <View
                        style={{
                            flexDirection: "row",
                            borderWidth: 1,
                            borderColor: "#000",
                            backgroundColor: "#f1f1f1", // Fondo para el encabezado
                        }}
                    >
                        <Text
                            style={{
                                flex: 1, // Ancho igual para ambas columnas
                                fontSize: 8,
                                fontWeight: "bold",
                                textAlign: "center",
                                padding: 5,
                                borderRightWidth: 1,
                                borderColor: "#000",
                            }}
                        >
                            Cantidad de Días Antes del Evento
                        </Text>
                        <Text
                            style={{
                                flex: 1,
                                fontSize: 8,
                                fontWeight: "bold",
                                textAlign: "center",
                                padding: 5,
                            }}
                        >
                            Porcentaje de Ingresos por Venta de Alimentos y Bebidas Acordada
                        </Text>
                    </View>

                    {/* Filas de la tabla */}
                    <View style={{ flexDirection: "row", borderWidth: 1, borderColor: "#000" }}>
                        <Text
                            style={{
                                flex: 1,
                                fontSize: 8,
                                textAlign: "center",
                                padding: 5,
                                borderRightWidth: 1,
                                borderColor: "#000",
                            }}
                        >
                            Fecha de firma hasta 30 días antes
                        </Text>
                        <Text
                            style={{
                                flex: 1,
                                fontSize: 8,
                                textAlign: "center",
                                padding: 5,
                            }}
                        >
                            30% de los Ingresos Totales Previstos por Alimentos y Bebidas, más impuestos aplicables
                        </Text>
                    </View>
                    <View style={{ flexDirection: "row", borderWidth: 1, borderColor: "#000" }}>
                        <Text
                            style={{
                                flex: 1,
                                fontSize: 8,
                                textAlign: "center",
                                padding: 5,
                                borderRightWidth: 1,
                                borderColor: "#000",
                            }}
                        >
                            29 – 11 días
                        </Text>
                        <Text
                            style={{
                                flex: 1,
                                fontSize: 8,
                                textAlign: "center",
                                padding: 5,
                            }}
                        >
                            50% de los Ingresos Totales, más impuestos aplicables
                        </Text>
                    </View>
                    <View style={{ flexDirection: "row", borderWidth: 1, borderColor: "#000" }}>
                        <Text
                            style={{
                                flex: 1,
                                fontSize: 8,
                                textAlign: "center",
                                padding: 5,
                                borderRightWidth: 1,
                                borderColor: "#000",
                            }}
                        >
                            10 – 0 días
                        </Text>
                        <Text
                            style={{
                                flex: 1,
                                fontSize: 8,
                                textAlign: "center",
                                padding: 5,
                            }}
                        >
                            100% de los Ingresos Totales Previstos por Alimentos y Bebidas, más impuestos aplicables
                        </Text>
                    </View>

                    <Text
                        style={{
                            fontSize: 8, // Tamaño de fuente legible
                            lineHeight: 1.4, // Espaciado entre líneas
                            textAlign: "justify",
                            marginTop: 10, // Espacio superior para separación
                        }}
                    >
                        El pago de los cargos por cancelación deberá realizarse: cuando el Cliente envíe al Hotel una notificación por escrito de la
                        cancelación. Todas las notificaciones de cancelación deberán cursarse por escrito y entrarán en vigor a partir de la fecha en
                        que se paguen los cargos por cancelación aplicables. El Hotel podría considerar que la notificación de cancelación del Cliente
                        es inválida y no liberar las Instalaciones hasta recibir el pago de los Cargos por Cancelación aplicables; por lo tanto, las
                        demoras en el pago podrían aumentar el monto de los Cargos por Cancelación que deban pagarse.
                    </Text>

                    <Text
                        style={{
                            fontSize: 8, // Mismo tamaño de fuente
                            lineHeight: 1.4, // Espaciado entre líneas
                            textAlign: "justify",
                            marginTop: 10, // Espaciado adicional para separación
                        }}
                    >
                        En caso de querer confirmar que el cálculo de los Cargos por Cancelación que deben pagarse es exacto, podrá comunicarse con
                        nosotros y solicitar que preparemos una declaración que detalle el cálculo de dichos cargos, más los impuestos aplicables.
                        Deduciremos cualquier pago adelantado y depósito que nos haya remitido anteriormente.
                    </Text>

                    {/* Títulos de las nuevas secciones */}
                    <Text
                        style={{
                            fontSize: 8, // Tamaño ligeramente mayor para destacar
                            fontWeight: "bold",
                            textAlign: "center",
                            marginTop: 20, // Separación visual
                            textTransform: "uppercase",
                        }}
                    >
                        Parte II: Términos Legales
                    </Text>

                    <Text
                        style={{
                            fontSize: 8,
                            fontWeight: "bold",
                            textAlign: "center",
                            marginTop: 10,
                            textTransform: "uppercase",
                        }}
                    >
                        Sección 1: Daños al Hotel
                    </Text>
                    {/* ahora este  */}
                    <Text
                        style={{
                            fontSize: 8, // Tamaño de fuente formal y legible
                            lineHeight: 1.4, // Espaciado entre líneas
                            textAlign: "justify",
                            marginTop: 10, // Espacio superior para separación
                        }}
                    >
                        En la máxima medida permitida por la ley, el Cliente asume responsabilidad total por cualquier daño sufrido por las
                        instalaciones y los bienes del Hotel durante el Evento (sin incluir el desgaste razonable), pero solo en la medida en que
                        dicho daño sea responsabilidad suya o de sus empleados, invitados, agentes o contratistas, incluido cualquier daño ocurrido
                        como resultado de la instalación, colocación y retiro de las muestras, equipos, exhibiciones u otros artículos del Cliente.
                    </Text>

                    <Text
                        style={{
                            fontSize: 8, // Tamaño mayor para destacar
                            fontWeight: "bold",
                            textAlign: "center",
                            marginTop: 20, // Separación del texto anterior
                            textTransform: "uppercase",
                        }}
                    >
                        Sección 2: Indemnización
                    </Text>

                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10, // Espaciado superior para iniciar nuevo párrafo
                        }}
                    >
                        En la máxima medida permitida por la ley, el Cliente se compromete a indemnizar, defender y mantener indemne al Hotel, sus
                        propietarios, gerentes, socios, subsidiarias, afiliadas, directivos, directores, empleados y agentes (colectivamente, las
                        “Partes Indemnizadas del Hotel”) contra cualquier reclamo de terceros, pérdidas o daños a personas o propiedades, cargos o
                        multas impuestos por gobiernos, sanciones y costos (incluidos los honorarios razonables de abogados) (colectivamente,
                        “Reclamo(s)”), que por cualquier motivo se relacionen con el Evento objeto de este Acuerdo, pero únicamente en la medida en
                        que tales reclamos sean consecuencia de la negligencia, negligencia grave o mala conducta intencionada de los empleados,
                        agentes, contratistas, expositores o asistentes del Cliente. Ningún aspecto de esta indemnización exigirá que el Cliente
                        indemnice a las Partes Indemnizadas del Hotel por la porción de cualquier reclamo que surja de la negligencia, negligencia
                        grave o mala conducta intencional de las Partes Indemnizadas del Hotel.
                    </Text>

                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10,
                        }}
                    >
                        En la máxima medida permitida por la ley, el Hotel se compromete a indemnizar, defender y mantener indemne al Cliente, sus
                        propietarios, gerentes, socios, subsidiarias, afiliadas, directivos, directores, empleados y agentes (colectivamente, las
                        “Partes Indemnizadas del Cliente”) contra cualquier reclamo (según dicho término se definió anteriormente) que por cualquier
                        motivo se relacionen con el Evento objeto de este Acuerdo, pero únicamente en la medida en que tales reclamos sean
                        consecuencia de la negligencia, negligencia grave o mala conducta intencionada de los empleados, agentes, o contratistas del
                        Hotel. Ningún aspecto de esta indemnización exigirá que el Hotel indemnice a las Partes Indemnizadas del Cliente por la
                        porción de cualquier reclamo que surja de la negligencia, negligencia grave o mala conducta intencional de las Partes
                        Indemnizadas del Cliente.
                    </Text>

                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10,
                        }}
                    >
                        Esta sección no implica una renuncia a ninguna limitación de responsabilidad que la ley ponga a disposición de cualquiera de
                        las partes, incluidas las leyes que limitan la responsabilidad de los propietarios de hoteles, ni a ninguna defensa que
                        cualquiera de las partes pueda tener con respecto a cualquier reclamo. Esta sección continuará en vigencia luego de la
                        extinción o cancelación de este Acuerdo.
                    </Text>

                    {/* Sección 3: Imposibilidad */}
                    <Text
                        style={{
                            fontSize: 8, // Tamaño mayor para destacar
                            fontWeight: "bold",
                            textAlign: "center",
                            marginTop: 20, // Separación visual
                            textTransform: "uppercase",
                        }}
                    >
                        Sección 3 – Imposibilidad (Fuerza Mayor)
                    </Text>

                    <Text
                        style={{
                            fontSize: 8, // Tamaño legible
                            lineHeight: 1.4, // Espaciado entre líneas
                            textAlign: "justify",
                            marginTop: 10, // Separación del encabezado
                        }}
                    >
                        Ninguna de las partes será responsable por incumplimientos de este Acuerdo si circunstancias imprevistas fuera de su control
                        (entre otras, las siguientes: hechos fortuitos, regulaciones gubernamentales, ataques terroristas en la ciudad en la que se
                        encuentra el Hotel o declaración de guerra en el país en el que se encuentra el Hotel) hacen que sea ilegal o imposible que el
                        Hotel celebre el Evento. La parte afectada podrá rescindir el presente Acuerdo sin incurrir en responsabilidad alguna, previa
                        notificación por escrito a la otra parte dentro de los primeros 10 días tras la ocurrencia del hecho. Si corresponde cancelar
                        el Evento debido a un hecho justificado de imposibilidad / fuerza mayor, entonces, a petición por escrito del cliente, el
                        Hotel se compromete a reembolsar al Cliente todos los depósitos prepagados o pagos por adelantado que haya recibido, sin hacer
                        ninguna deducción. Esta sección no autoriza a cancelar el Evento debido a las condiciones económicas generales, incluidos
                        cualquier recesión o recorte del presupuesto público. Las partes convienen en negociar de buena fe para volver a reservar
                        cualquier Evento cancelado debido a una situación válida de imposibilidad/fuerza mayor, en cuyo caso los depósitos prepagados
                        podrán aplicarse a la nueva reserva del Evento.
                    </Text>

                    {/* Sección 4: Disposiciones Generales */}
                    <Text
                        style={{
                            fontSize: 8,
                            fontWeight: "bold",
                            textAlign: "center",
                            marginTop: 20,
                            textTransform: "uppercase",
                        }}
                    >
                        Sección 4: Disposiciones Generales
                    </Text>

                    {/* Derecho Aplicable */}
                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10,
                        }}
                    >
                        (1 Derecho Aplicable) Este acuerdo se regirá e interpretará de conformidad con las leyes del estado y país donde se ubica el
                        Hotel.
                    </Text>

                    {/* Resolución de Controversias */}
                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10,
                        }}
                    >
                        (2 Resolución de Controversias) Las partes acuerdan hacer esfuerzos de buena fe para resolver cualquier controversia, para lo
                        que las someterán la consideración de sus representantes senior. Si a pesar de tales negociaciones las partes no son capaces
                        de resolver la controversia, la diferencia será resuelta ante un tribunal con competencia en la ciudad donde se ubique el
                        Hotel (o el lugar más cercano disponibles).
                    </Text>

                    {/* Honorarios de Abogados */}
                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10,
                        }}
                    >
                        (3 Honorarios de Abogados y Costas Judiciales) Las partes convienen en que aquella que resulte vencedora en cualquier
                        procedimiento judicial relacionado con este Acuerdo tendrá derecho a que se le reembolsen todas las sumas pagadas por
                        honorarios de abogados y peritos expertos, los gastos y los intereses previos y posteriores a la sentencia, según la máxima
                        tasa permitida por la ley. Asimismo, las partes convienen en que si el Hotel necesita contratar un abogado o iniciar un
                        procedimiento judicial o de arbitraje para cobrar cualquier suma que el Cliente le adeude en virtud de este Acuerdo, sea o no
                        que se inicie una acción judicial, el Hotel tendrá derecho a que se le reembolsen los honorarios razonables de abogado que
                        haya debido pagar para cobrar las sumas adeudadas.
                    </Text>

                    {/* Controversias Sobre Pagos con Tarjetas de Crédito */}
                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10,
                        }}
                    >
                        (4 Controversias Sobre Pagos con Tarjetas de Crédito) Como condición para que el Hotel acepte la tarjeta de crédito del
                        Cliente como medio habilitado de pago, el cliente conviene en que cualquier objeción que pudiera presentar con respecto a
                        cualquier cargo en la Cuenta Maestra deberá ser tratada directamente por el cliente y el Hotel, y las partes acuerdan cooperar
                        de buena fe para resolver sin demora cualquier objeción a una factura. Todas las disputas que no puedan resolverse dentro de
                        los plazos previstos y a la satisfacción mutua de las partes se resolverán aplicando las disposiciones consignadas
                        anteriormente para la resolución de controversias.
                    </Text>
                    {/* Controversias Sobre Pagos con Tarjetas de Crédito */}
                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10,
                        }}
                    >
                        (4. Controversias Sobre Pagos con Tarjetas de Crédito) Como condición para que el Hotel acepte la tarjeta de crédito del
                        Cliente como medio habilitado de pago, el cliente conviene en que cualquier objeción que pudiera presentar con respecto a
                        cualquier cargo en la Cuenta Maestra deberá ser tratada directamente por el cliente y el Hotel, y las partes acuerdan cooperar
                        de buena fe para resolver sin demora cualquier objeción a una factura. Todas las disputas que no puedan resolverse dentro de
                        los plazos previstos y a la satisfacción mutua de las partes se resolverán aplicando las disposiciones consignadas
                        anteriormente para la resolución de controversias.
                    </Text>

                    {/* Cumplimiento con las Leyes */}
                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10,
                        }}
                    >
                        (5 Cumplimiento con las Leyes) Cada una de las partes se compromete a cumplir con todas las leyes y disposiciones aplicables
                        relativas al Evento objeto de este acuerdo, lo que incluye, entre otros, códigos de salud y seguridad, leyes y normas contra
                        el terrorismo, la corrupción y el lavado de dinero y normas para situaciones de incendio. Cada una de las partes se compromete
                        a cooperar con la otra y con cualquier autoridad gubernamental que corresponda para garantizar el cumplimiento de dichas leyes
                        y normas. El cliente reconoce expresamente y acuerda que la capacidad del Hotel de cumplir sus obligaciones en virtud de este
                        Acuerdo depende de que cumpla con todas las leyes correspondientes. Además de cualquier otra reparación y derecho legal que
                        las leyes actuales le otorguen al Hotel, el Hotel podrá cancelar el evento y este Acuerdo sin incurrir en obligaciones frente
                        a ninguna persona si cree razonablemente que es necesario hacerlo para poder cumplir las obligaciones que le impongan las
                        leyes y normas aplicables.
                    </Text>

                    {/* Declaración de Limitación de Responsabilidad */}
                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10,
                        }}
                    >
                        (6. Declaración de Limitación de Responsabilidad) En la máxima medida permitida por la ley, el Cliente acepta que en ninguna
                        circunstancia el Hotel, su propietario o Hilton serán responsables por ningún servicio o producto que cualquier tercero
                        proveedor o contratista (incluidos, entre otros, empresas que brindan servicios de registro o gestión de reuniones, floristas,
                        decoradores, músicos, profesionales audiovisuales) brinden o vayan a brindar al Cliente, ni por ninguna obligación que surja
                        de un acuerdo celebrado entre el Cliente y cualquier tercero proveedor o contratista que el Cliente contrate para que brinde
                        servicios durante el Evento. La presente declaración de limitación de responsabilidad será de aplicación aun si dicho tercero
                        proveedor o contratista fue recomendado por el Hotel al Cliente o era un proveedor preferido del Hotel, o si paga comisiones
                        al Hotel o le brinda otros incentivos basados en los servicios que ofrece y que el Cliente paga.
                    </Text>

                    {/* Acuerdo Total Enmiendas */}
                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10,
                        }}
                    >
                        (7. Acuerdo Total Enmiendas) Este Acuerdo refleja la totalidad del convenio entre las partes con respecto al Evento, y
                        reemplaza a todos los acuerdos, comunicaciones, declaraciones o convenios previos, fueran verbales o escritos. Todas las
                        enmiendas a este Acuerdo deberán realizarse por escrito y estar firmadas por un representante autorizado de cada una de las
                        partes; con la salvedad de que podrá llamar por teléfono para expresar su garantía definitiva de que asistirá a las funciones
                        que impliquen la provisión de alimentos y bebidas. Las firmas enviadas o recibidas por correo electrónico en un documento
                        escaneado con la firma adjunta o que se transmitan por fax se considerarán igual de exigibles y válidas que la firma original
                        de la parte firmante.
                    </Text>

                    <Text
                        style={{
                            fontSize: 8,
                            lineHeight: 1.4,
                            textAlign: "justify",
                            marginTop: 10,
                        }}
                    >
                        La devolución de este Acuerdo firmado, pero con cambios, no se considerará una aceptación, sino una contraoferta de su parte
                        que nosotros podremos aceptar o rechazar por escrito a nuestro exclusivo criterio. Una vez que ambas partes firmen este
                        Acuerdo, todos los alojamientos reservados en su nombre quedarán confirmados y, con ello, sujetos a los términos de este
                        Acuerdo. Cada persona que firma este Acuerdo garantiza estar debidamente autorizada para vincular a la parte en representación
                        de la cual está firmando.
                    </Text>

                    <View style={{ marginTop: 30 }}>
                        {/* Primera fila */}
                        <View style={{ flexDirection: "row", justifyContent: "space-around", marginBottom: 30 }}>
                            {/* Firma Cliente */}
                            <View style={{ alignItems: "center", width: "30%" }}>
                                <Text style={{ fontSize: 10, textAlign: "center" }}>_______________________________</Text>
                                <Text style={{ fontSize: 8, textAlign: "center", color: "gray" }}>FIRMA CLIENTE</Text>
                            </View>

                            {/* Nombre Cliente */}
                            <View style={{ alignItems: "center", width: "30%" }}>
                                <Text style={{ fontSize: 10, textAlign: "center" }}>_______________________________</Text>
                                <Text style={{ fontSize: 8, textAlign: "center", color: "gray" }}>NOMBRE CLIENTE</Text>
                            </View>

                            {/* Fecha */}
                            <View style={{ alignItems: "center", width: "30%" }}>
                                <Text style={{ fontSize: 10, textAlign: "center" }}>_______________________________</Text>
                                <Text style={{ fontSize: 8, textAlign: "center", color: "gray" }}>FECHA</Text>
                            </View>
                        </View>

                        {/* Segunda fila */}
                        <View style={{ flexDirection: "row", justifyContent: "space-around" }}>
                            {/* Hotel */}
                            <View style={{ alignItems: "center", width: "30%" }}>
                                <Text style={{ fontSize: 10, textAlign: "center" }}>{formulario.admin_hotel}</Text>
                                <Text style={{ fontSize: 10, textAlign: "center", textDecoration: "underline" }}>
                                    _______________________________
                                </Text>
                                <Text style={{ fontSize: 8, textAlign: "center", color: "gray" }}>HOTEL</Text>
                            </View>

                            {/* Nombre Ejecutiva */}
                            <View style={{ alignItems: "center", width: "30%" }}>
                                <Text style={{ fontSize: 10, textAlign: "center" }}>{formulario.admin_name}</Text>
                                <Text style={{ fontSize: 10, textAlign: "center", textDecoration: "underline" }}>
                                    _______________________________
                                </Text>
                                <Text style={{ fontSize: 8, textAlign: "center", color: "gray" }}>NOMBRE EJECUTIVA</Text>
                            </View>

                            {/* Fecha */}
                            <View style={{ alignItems: "center", width: "30%" }}>
                                <Text style={{ fontSize: 10, textAlign: "center" }}>{formulario.admin_fecha}</Text>
                                <Text style={{ fontSize: 10, textAlign: "center", textDecoration: "underline" }}>
                                    _______________________________
                                </Text>
                                <Text style={{ fontSize: 8, textAlign: "center", color: "gray" }}>FECHA</Text>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
        </Page>
    </Document>
);

// Componente para descargar el PDF
const PDFDownload = ({ formulario, nombre, mostrarPoliticasCortas }) => {
    // Obtener la moneda activa o asignar un valor predeterminado.
    const monedaActiva = formulario.MonedaTipo.find((moneda) => moneda.estado)?.nombre || "$";

    return (
        <PDFDownloadLink
            document={<PDFGenerator formulario={formulario} monedaActiva={monedaActiva} />}
            fileName={`${nombre}_${formulario.consecutivo}.pdf`} // Corregida la interpolación
        >
            {({ loading }) => (
                <button type="button" className="btn btn-success me-2">
                    {loading ? (
                        <>
                            <i className="ti ti-spinner ti-spin"></i> Generando PDF...
                        </>
                    ) : (
                        <>
                            <i className="ti ti-download"></i> Descargar {nombre}
                        </>
                    )}
                </button>
            )}
        </PDFDownloadLink>
    );
};

export default PDFDownload;
